const DEFAULT_INTERVAL_MS = 120;
const DEFAULT_TIMEOUT_MS = 12000;

/**
 * Polls the DOM until a selector matches or timeout elapses.
 *
 * @param {string} selector
 * @param {Object} [options]
 * @param {number} [options.intervalMs]
 * @param {number} [options.timeoutMs]
 * @param {AbortSignal} [options.signal]
 * @returns {Promise<Element | null>}
 */
export function waitForElement(selector, options = {}) {
  const {
    intervalMs = DEFAULT_INTERVAL_MS,
    timeoutMs = DEFAULT_TIMEOUT_MS,
    signal,
  } = options;

  if (!selector || typeof document === "undefined") {
    return Promise.resolve(null);
  }

  return new Promise((resolve) => {
    const existing = document.querySelector(selector);
    if (existing) {
      resolve(existing);
      return;
    }

    let settled = false;
    const startedAt = Date.now();

    const finish = (element) => {
      if (settled) {
        return;
      }
      settled = true;
      window.clearInterval(timerId);
      signal?.removeEventListener("abort", onAbort);
      resolve(element);
    };

    const onAbort = () => finish(null);

    const timerId = window.setInterval(() => {
      if (signal?.aborted) {
        finish(null);
        return;
      }

      const element = document.querySelector(selector);
      if (element) {
        finish(element);
        return;
      }

      if (Date.now() - startedAt >= timeoutMs) {
        finish(null);
      }
    }, intervalMs);

    signal?.addEventListener("abort", onAbort, { once: true });
  });
}
